import { Trash2, Download, FileText, ExternalLink, Loader2, RefreshCw, AlertCircle } from "lucide-react";
import { formatDate } from "../../lib/api";

function prettySize(b) {
  const n = Number(b || 0);
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  return `${(n / 1024 / 1024).toFixed(1)} MB`;
}

export function DriveFileRow({ f, busy, onDownload, onDelete, onRescan }) {
  return (
    <div className="flex items-center gap-3 px-3 py-2" data-testid={`drive-file-${f.id}`}>
      <FileText className="w-4 h-4 text-[#C84B31] shrink-0" />
      <div className="min-w-0 flex-1">
        <div className="text-sm text-[#1A1A18] truncate">{f.name}</div>
        <div className="text-[11px] text-[#68665E]">
          {f.doc_type ? <span className="font-medium">{f.doc_type}</span> : null}
          {f.doc_type ? " · " : ""}{prettySize(f.size)} · {formatDate(f.uploaded_at)}
        </div>
        {f.parse_status === "pending" && (
          <div className="text-[11px] text-[#C84B31] flex items-center gap-1 mt-0.5" data-testid={`drive-parsing-${f.id}`}>
            <Loader2 className="w-3 h-3 animate-spin" /> AI reading document…
          </div>
        )}
        {(f.parse_status === "skipped" || f.parse_status === "failed") && (
          <div className="text-[11px] text-[#B4791F] flex items-center gap-1 mt-0.5" data-testid={`drive-unread-${f.id}`}>
            <AlertCircle className="w-3 h-3" /> Not read yet — tap re-scan to read this document
          </div>
        )}
        {f.parse_status === "done" && f.parsed && (
          <div className="flex flex-wrap gap-x-3 gap-y-0.5 text-[11px] text-[#68665E] mt-0.5" data-testid={`drive-parsed-${f.id}`}>
            {f.parsed.ewb_number && <span>EWB: <span className="text-[#1A1A18] font-medium font-mono">{f.parsed.ewb_number}</span></span>}
            {f.parsed.ewb_valid_until && <span>Valid till: <span className="text-[#1A1A18] font-medium">{f.parsed.ewb_valid_until}</span></span>}
            {f.parsed.doc_number && <span>No: <span className="text-[#1A1A18] font-medium">{f.parsed.doc_number}</span></span>}
            {f.parsed.doc_date && <span>Date: <span className="text-[#1A1A18] font-medium">{f.parsed.doc_date}</span></span>}
            {f.parsed.amount != null && <span>Amt: <span className="text-[#1A1A18] font-medium">₹{Number(f.parsed.amount).toLocaleString("en-IN")}</span></span>}
            {f.parsed.party_name && <span>Party: <span className="text-[#1A1A18] font-medium">{f.parsed.party_name}</span></span>}
          </div>
        )}
      </div>
      {onRescan && (
        <button className="btn-ghost" onClick={() => onRescan(f)} disabled={busy || f.parse_status === "pending"} title="Re-scan document with AI" data-testid={`drive-rescan-${f.id}`}>
          <RefreshCw className={`w-4 h-4 ${f.parse_status === "pending" ? "animate-spin" : ""}`} />
        </button>
      )}
      {f.web_view_link && (
        <a href={f.web_view_link} target="_blank" rel="noreferrer" className="btn-ghost" title="Open in Google Drive" data-testid={`drive-open-${f.id}`}>
          <ExternalLink className="w-4 h-4" />
        </a>
      )}
      <button className="btn-ghost" onClick={() => onDownload(f)} disabled={busy} title="Download" data-testid={`drive-download-${f.id}`}>
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Download className="w-4 h-4" />}
      </button>
      <button className="btn-ghost text-[#8A2526]" onClick={() => onDelete(f)} disabled={busy} title="Delete" data-testid={`drive-delete-${f.id}`}>
        <Trash2 className="w-4 h-4" />
      </button>
    </div>
  );
}
